const ZERO_DECIMAL_CURRENCIES = new Set([
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "JPY",
  "KMF",
  "KRW",
  "MGA",
  "PYG",
  "RWF",
  "UGX",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF",
]);

export function normalizeAdCurrencyCode(currency: string | undefined): string {
  return currency && /^[A-Z]{3}$/i.test(currency)
    ? currency.toUpperCase()
    : "USD";
}

export function formatAdMoney(
  amount: number | string | undefined | null,
  currency: string | undefined
): string {
  if (amount == null || Number.isNaN(Number(amount))) return "—";

  const code = normalizeAdCurrencyCode(currency);
  const zeroDecimal = ZERO_DECIMAL_CURRENCIES.has(code);
  const value = Number(amount);

  try {
    return new Intl.NumberFormat(code === "CLP" ? "es-CL" : undefined, {
      style: "currency",
      currency: code,
      minimumFractionDigits: zeroDecimal ? 0 : 2,
      maximumFractionDigits: zeroDecimal ? 0 : 2,
    }).format(value);
  } catch {
    return `${value.toLocaleString()} ${code}`;
  }
}
